exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card .card-header[data-v-762f771e]{padding-left:0!important}.collapse-icon.left a[data-v-762f771e]:after,.collapse-icon.left a[data-v-762f771e]:before{left:0}", ""]);

